import { HorizontalBar, mixins } from 'vue-chartjs';

export default {
  name: 'horizontal-bar-chart',
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp],
  props: {
    extraOptions: Object
  },
  data() {
    return {
      ctx: null
    };
  },
  methods: {
    
  },
  mounted() {
    this.$watch('chartData', (newVal, oldVal) => {
      if (!oldVal) {
        this.renderChart(
          this.chartData,
          this.extraOptions
        );
      }
    }, { immediate: true });
  }
};
